import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import Header from "../Header";
import AppContext from "../../../contexts/AppContext";
import { sendResetEmail } from "../../../services/user";

class Reset extends Component {
    state = {
        item: {},
        errors: {},
		loading: false,
    };

    onChange = field => {
        let temp = this.state.item;
        temp[field.target.name] = field.target.value;

        let error = this.state.errors;
        error[field.target.name] = null;

        this.setState({ item: temp, errors: error });
    };
	
	submitReset = e => {
        e.preventDefault();
		this.setState({loading: true});
        sendResetEmail(this.state.item)
            .then(res => {
				this.setState({loading: false});
				this.context.state.showCodeMessage(res.message,'success');
                this.props.history.push("/email/recoverSent");
                this.context.state.setRecoverEmail(this.state.item.email);
            })
            .catch(error => {
				this.setState({loading: false});
				switch (error.response.status) {
                    case 422:
                        this.setState({ errors: error.response.data.error });
                        break;
                    default:
                        this.context.state.handelError(error);
                        break;
                }
            });
    };
    componentDidMount() {
        this.nameInput.focus();
    }
    render() {
        return (
            <Fragment>
                 <div className="model-container model-center model-backdrop-show cardModalAction sign-in-model">
			        <button onClick={this.props.toggleResetPassword} type="button" className="modal-close" data-dismiss="modal" aria-hidden="true"><img src="/images/close.svg" alt="close"/></button>
                    <div
                        aria-labelledby="model-title"
                        aria-describedby="model-content"
                        className="model-popup model-modal model-show"
                        role="dialog"
                        aria-live="assertive"
                        aria-modal="true"
                    >
                        <div className="title d-flex align-items-center justify-content-between">
				    	    <h2 className="model-title m-0" id="model-title">
                                Reset Password
                            </h2>
				    	    <p className="small-text">
				    	        Not a member?  
				    	        <Link className="ml-2" tabIndex="5" to="/register">
                                    Sign up
                                </Link>
				    	    </p>
				    	</div>
                        <div className="modal-body">
                            <form onSubmit={this.submitReset} method="POST">
                                <div className="form-group">
                                    <label className="bold">
                                        Email address
                                    </label>

                                    <input
                                        ref={input => {
                                            this.nameInput = input;
                                        }}
                                        onChange={this.onChange}
                                        type="text"
                                        className={
                                            this.state.errors.email
                                                ? "is-invalid form-control  form-control-large"
                                                : " form-control  form-control-large"
                                        }
                                        name="email"
                                        autoComplete="off"
                                        placeholder="Enter your email"
                                    />
                                    {this.state.errors.email ? (
                                        <div className="invalid-feedback">
                                            {this.state.errors.email}
                                        </div>
                                    ) : null}
                                </div>

                                <button
								    disabled={this.state.loading}
                                    className="form-control-large bold btn btn-lg btn-block btn-primary mb-3 mt-5"
                                    onClick={this.submitReset}
                                >
                                    <i className={this.state.loading ? `mr-2 fas fa-spinner fa-spin` : `mr-2 fas fa-shield-alt`}></i> {this.state.loading ? `Processing...` : `Reset Password`}
                                </button>
								<p className="text-center">
                                    <small className="text-muted text-center">
									    {/*Don't have an account yet?{" "}
                                            <Link to={`/register`}>
                                                Sign up
                                            </Link>
	                                    .*/}
										Contact support at <a href="mailto:support@prowriter.co">support@prowriter.co</a>
                                    </small>
                                </p>
                            </form>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

Reset.contextType = AppContext;
export default Reset;



// WEBPACK FOOTER //
// ./src/components/auth/password/Reset.js